document.addEventListener('DOMContentLoaded', function() {

    const productCollectionSlider = () => {
        if (!document.querySelector('.glide--product-collection-slider') || typeof Glide === 'undefined') {
            return;
        }

        const glide = new Glide('.glide--product-collection-slider', {
            type: 'slider',
            gap: 8,
            perView: 3,
            bound: true,
            rewind: false,
            throttle: 100,
            peek: {
                before: 0,
                after: 64
            },
            breakpoints: {
                620: {
                    perView: 2,
                    gap: 16,
                }
            }
        });

        glide.mount();
    }

    productCollectionSlider();
});
